<template>
	<div class="scr_dv">
		<playHead></playHead>
		<div id="dark0" class="swiper">
			<el-carousel height="70vh" :interval="3000" trigger="click" ref="carousel"
				@mouseenter.native="delHandleMouseEnter" arrow="always">
				<el-carousel-item v-for="item in swiperList" :key="item.advertisingId">
					<img class="swiperImg" :src="item.advertisingImage">
				</el-carousel-item>
			</el-carousel>
			<button class="togame" @click="toGame">立即参赛</button>
		</div>
		<div class="" ref="menu_height" style="height: 92px;">
			<div class="ac_span" :class="{'menu_fixed':menuFixed}">
				<span :class="{ 'nav-selected': selectNav == 0 }" @click="jump(0)">首页</span>
				<span :class="{ 'nav-selected': selectNav == 1 }" @click="jump(1)">赛事详情</span>
				<span :class="{ 'nav-selected': selectNav == 2 }" @click="jump(2)">关于</span>
				<span v-if="$store.state.appUser" :class="{ 'nav-selected': selectNav == 3 }"
					@click="jump(3)">我的投稿</span>
			</div>
		</div>

		<div class="scr_dv">
			<!-- 详情 -->
			<detailsHtml />
		</div>
		<div class="scr_dv">
			<!-- 关于 -->
			<aboutHtml />
		</div>
		<!-- 我的投稿 -->
		<div class="scr_dv" v-if="$store.state.appUser">
			<!-- 发布作品 -->
			<div class=" flexween" v-if="total!=0">
				<h2 class="">共发布<span>{{total}}</span>组作品</h2>
			</div>
			<worklist :listNum="4" :list="workList" @iconClick="iconClick" @toDetails="toDetails"></worklist>
		</div>
	</div>
</template>

<script>
	import playHead from './components/playhead.vue'
	import worklist from './components/worklist.vue'
	import detailsHtml from './components/details.vue'
	import aboutHtml from './components/about.vue'
	export default {
		name: 'goodplay',
		components: {
			playHead,
			worklist,
			detailsHtml,
			aboutHtml
		},
		data() {
			return {
				swiperList: [],
				userlist: [],
				workList: [],
				dictArr: [],
				total: 0,
				menuFixed: false,
				selectNav: 0,
				menuHeight: 0
			};
		},
		mounted() {
			window.addEventListener('scroll', this.scrollTop)
		},
		created() {
			this.getSwiper()
			this.getDict()
			this.$nextTick(() => {
				this.menuHeight = this.$refs.menu_height.offsetHeight
			})
		},
		methods: {
			jump(index) {
				this.selectNav = index
				var inner = document.getElementsByClassName('scr_dv');
				window.scrollTo({
					top: inner[index].offsetTop - this.menuHeight,
					behavior: 'smooth'
				})
			},
			scrollTop() {
				this.menuFixed = false
				if (document.documentElement.scrollTop > 552) this.menuFixed = true
			}, //参赛按钮
			toGame() {
				if (!this.$store.state.appUser) {
					this.$msg.error('需要登录嗷~');
					this.$router.push({
						name: 'login',
						query: {
							type: 'op'
						}
					})
				} else {
					this.$router.push('playupwork')
				}
			},
			delHandleMouseEnter() {
				this.$refs.carousel.handleMouseEnter = () => {};
			},
			async getSwiper() {
				const res = await this.$axios.get('/front/getAdvertisingByLocation', {
					advertisingLocation: 'index-banner'
				})
				this.swiperList = res.data;
			},
			//上传的作品详情
			async getDict() {
				const res = await this.$axios.get('/front/dict', {
					dictType: 'app_event_opera_trace'
				})
				this.dictArr = res.data
				this.getlist()
			},
			//获取列表
			async getlist(id, index) {
				//暂时不做作品数量限制
				let params = {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
				}
				const res = await this.$axios.get('/front/eventOpera/listWorks')
				this.total = res.total

				res.rows.forEach(item => {
					this.dictArr.forEach(v => {
						if (item.track == v.dictValue) item.dictLabel = v.dictLabel
					})
				})
				this.workList = res.rows
			},
			toDetails(item) {
				this.$router.push({
					name: "playdetails",
					query: {
						eventOperaWorkId: item.eventOperaWorkId
					}
				})
			},

			//点击三个点
			iconClick(val) {
				// 去修改
				if (val.e == 1) {
					this.$router.push({
						name: 'playupwork',
						query: {
							status: 1,
							eventOperaWorkId: val.data.eventOperaWorkId
						}
					})
				}
				//删除当前订单
				if (val.e == 2) {
					this.$confirm('确定要删除该作品？<br>一旦删除，我们将不会保留您的作品信息', '删除作品', {
						confirmButtonText: '确认',
						cancelButtonText: '取消',
						type: 'warning',
						dangerouslyUseHTMLString: true
					}).then(() => {
						this.$axios.get('/front/eventOpera/deleteWork', {
							'eventOperaWorkId': val.data
						}).then(res => {
							if (res.code == 200) this.$msg.success('删除成功')
							this.workList.splice(val.index, 1)
						})
					}).catch(() => {});
				}
			},

		}
	}
</script>
<style lang="scss" scoped>
	.nav-selected {
		background-color: red;
	}



	.ac_span {
		position: relative;
		top: -1px;
		width: 100%;
		background-color: white;
		display: flex;
		justify-content: space-around;
		border-top: 1px solid var(--border);
		padding: 20px 0;

		span {
			border: 1px solid #fc2d39;
			line-height: 50px;
			padding: 0 40px;
			width: 100px;
			font-size: 16px;
			text-align: center;
			cursor: pointer;
			transition-duration: .2s;

			&:hover {
				background-color: #fc2d39;
				color: white;
			}
		}

	}

	.menu_fixed {
		position: fixed;
		top: 82px;
		z-index: 23;
	}

	.togame {
		position: absolute;
		right: 20px;
		border: none;
		bottom: 20px;
		z-index: 9;
		background-color: #fc2d39;
		color: white;
		line-height: 50px;
		text-align: center;
		width: 180px;
		font-size: 16px;

	}

	.swiper {
		margin-top: 82px;
		position: relative;
	}
</style>
